import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_VIEW_CONSULTATION,
    getViewConsultationFail,
    getViewConsultationSuccess
} from '../action/getViewConsultation'

// api 
import getViewConsultationApi from '../api/getViewConsultationApi'

export function* getViewConsultationSage(action) {
    try {
        const response = yield call(() => getViewConsultationApi(action.params))
        console.log("reso", response)
        if (response.data.statusCode === 200) {
            yield put(getViewConsultationSuccess(response, action))
        } else {
            yield put(getViewConsultationFail(response, action))
        }
    }
    catch (e) {
        yield put(getViewConsultationFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_VIEW_CONSULTATION, getViewConsultationSage)
}